<template>
  <div class="main">
    <img width="100%" :src="status.title" />
    <section :class="sectionStepClass">
      <div
        class="info-message"
        v-html="status.msg"
        :style="infoMessageStyle"
      ></div>
      <img
        :src="status.info"
        width="95%"
        style="display: block;margin: 0 auto;"
      />
      <div class="button" @click="appDownload">
        <img
          v-if="user_status === 'FINISHED'"
          src="../assets/image/btnBtnLogin.png"
        />
        <img v-else src="../assets/image/btnBtnDownload.png" />
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'Finish',
  data() {
    return {
      phone_number: '',
      expiration_date: '',
      user_status: this.$route.query.s,
      message: {
        PRAYING_CASH: {
          RESERVED: {
            title: require('../assets/image/titleTitleSuccess.png'),
            msg: `已成功為<span>${this.phone_number}</span>保留結緣金<br />請於 <span> ${this.expiration_date} </span>前領取。`,
            info: require('../assets/image/reservePrayingCash.png')
          },
          FINISHED: {
            title: require('../assets/image/titleTitlePlsLogIn.png'),
            msg: '',
            info: require('../assets/image/getPrayingCash.png')
          }
        },
        RED_ENVELOPES: {
          RESERVED: {
            title: require('../assets/image/titleTitleSuccess.png'),
            msg: `已成功為<span>${this.phone_number}</span>保留紅包<br />請於 <span> ${this.expiration_date} </span>前領取。`,
            info: require('../assets/image/reserveRed.png')
          },
          FINISHED: {
            title: require('../assets/image/titleTitlePlsLogInRed.png'),
            msg: '',
            info: require('../assets/image/getRed.png')
          }
        },
        CHINESE_VALENTINES: {
          RESERVED: {
            title: require('../assets/image/titleCVdayKvSuccess.png'),
            msg: `已成功為<span>${this.phone_number}</span>保留姻緣金<br />請於 <span> ${this.expiration_date} </span>前領取。`,
            info: require('../assets/image/reserveCVday.png')
          },
          FINISHED: {
            title: require('../assets/image/titleCVdayKvLogIn.png'),
            msg: '',
            info: require('../assets/image/getCVday.png')
          }
        }
      }
    };
  },
  beforeCreate() {
    this.phone_number = sessionStorage.getItem('formatPhoneNumber');
    this.expiration_date = sessionStorage.getItem('formatDateTime');
  },
  computed: {
    status() {
      let type = this.$route.query.t;
      let status = this.$route.query.s;

      return this.message[type][status];
    },
    sectionStepClass() {
      let className;
      if (this.user_status === 'RESERVED') {
        switch (this.$route.query.t) {
          case 'PRAYING_CASH':
          case 'RED_ENVELOPES':
            className = 'praying-reserved';
            break;
          case 'CHINESE_VALENTINES':
            className = 'CVday-reserved';
            break;
        }
      } else {
        switch (this.$route.query.t) {
          case 'PRAYING_CASH':
          case 'RED_ENVELOPES':
            className = 'praying-finish';
            break;
          case 'CHINESE_VALENTINES':
            className = 'CVday-finish';
            break;
        }
      }
      return className;
    },
    infoMessageStyle() {
      let style;
      if (this.$route.query.s === 'RESERVED') {
        switch (this.$route.query.t) {
          case 'PRAYING_CASH':
          case 'RED_ENVELOPES':
            style = {};
            break;
          case 'CHINESE_VALENTINES':
            style = { top: '-5rem' };
            break;
        }
      }
      return style;
    }
  },
  methods: {
    appDownload() {
      window.location.href = `/app/download`;
    }
  }
};
</script>
<style type="text/scss" lang="scss" scoped>
.praying-reserved {
  position: relative;
  top: -14rem;
}

.praying-finish {
  position: relative;
  top: -8rem;
}

.CVday-reserved {
  position: absolute;
  top: 15rem;
}

.CVday-finish {
  position: absolute;
  top: 21rem;
}

@media screen and (max-width: 767px) {
  .praying-reserved {
    top: -17rem;
  }

  .CVday-reserved {
    top: 21rem;
  }

  .CVday-finish {
    top: 29rem;
  }
}

@media screen and (max-width: 375px) {
  .CVday-reserved {
    top: 19rem;
  }

  .CVday-finish {
    top: 26rem;
  }
}

@media screen and (max-width: 320px) {
  .CVday-reserved {
    top: 10rem;
  }
  .info-message {
    top: 0 !important;
    font-size: var(--font-35);
  }
}
</style>
